export default {
  set(state, { data }) {
    state.orders = data;
  },
  show(state, { data }) {
    state.order = data;
  },
  getPage(state, { data }) {
    state.page = data
  }
}